/* eslint-disable import/no-anonymous-default-export */

import apiCall from "./apiCall";

export default {
  /**
   * !!! DEPRECATED
   */
  async accountStatement(accountId, periodId, openingDate, closingDate, page) {
    let data = {
      account_id: accountId,
      period_id: periodId,
      opening_date: openingDate,
      closing_date: closingDate,
      page: page,
    };
    let response = await apiCall("reports/account-statement", data);
    return response;
  },

  async getHighIncomeStatement(periodId, tagId, openingDate, closingDate) {
    let data = {
      period_id: periodId,
      tag_id: tagId,
      type: "high",
      opening_date: openingDate,
      closing_date: closingDate,
    };
    let response = await apiCall("reports/income-statement/high", data);
    return response;
  },

  async getTrialBalance(periodId, openingDate, closingDate) {
    let data = {
      period_id: periodId,
      type: "high",
      opening_date: openingDate,
      closing_date: closingDate,
    };
    let response = await apiCall("reports/trial-balance", data);
    return response;
  },

  async getBalanceSheet(periodId, openingDate, closingDate) {
    let data = {
      period_id: periodId,
      type: "high",
      opening_date: openingDate,
      closing_date: closingDate,
    };
    let response = await apiCall("reports/balance-sheet", data);
    return response;
  },

  async fetchVendorStatement(vendorId, periodId, openingDate, closingDate, page) {
    let data = {
      vendor_id: vendorId,
      period_id: periodId,
      opening_date: openingDate,
      closing_date: closingDate,
      page: page,
    };
    let response = await apiCall("reports/vendor-statement", data);
    return response;
  },

  async fetchMonthlyIncomeGraph(data) {
    let response = await apiCall("report/incomestatement/monthly_income_graph", data);
    return response;
  },

  async fetchWeeklyIncomeGraph(data) {
    let response = await apiCall("report/incomestatement/weekly_income_graph", data);
    return response;
  },

  async fetchAccountStatement(data) {
    let response = await apiCall("report/accountstatement/account_statement", data);
    return response;
  },

  async fetchTrialBalanceReport(data) {
    let response = await apiCall("report/trialbalance/report_by_level", data);
    return response;
  },

  async fetchIncomeStatementReport(data) {
    let response = await apiCall("report/incomestatement/report", data);
    return response;
  },
  
  async fetchBalanceSheetReport(data) {
    let response = await apiCall("report/balancesheet/report", data);
    return response;
  },

  async fetchDailyCashFlow(data) {
    let response = await apiCall("report/cashflow/daily_cash_flow", data);
    return response;
  },
  
  
};
